import { HttpErrorResponse } from '@angular/common/http';
import { FirebaseError } from '@angular/fire/app';
import { createFeature, createReducer, on } from '@ngrx/store';
import * as fromActions from '../actions/auth.actions';
import * as UserActions from '../actions/user.actions';
import { GetUserDto } from '../dtos/getUserDto.type';


export interface FeatureState {
    currentUser: GetUserDto | undefined;
    signUpData: any | undefined;
    error: HttpErrorResponse | FirebaseError | undefined;
}
export interface AppState {
    aumicoUsersAuthMicroservice: FeatureState;
}

// Selectors Declarations - END

// Reducer Declarations - START

export const initialState: FeatureState = {
    currentUser: undefined,
    signUpData: undefined,
    error: undefined,
};

const usersReducer = createReducer(
    initialState,

    on(fromActions.login.do, (state: FeatureState) => ({ ...state, error: undefined })),
    on(fromActions.login.success, (state: FeatureState, action) => ({
        ...state,
        error: undefined,
    })),
    on(fromActions.login.failure, (state: FeatureState, action) => ({
        ...state,
        error: action.payload,
    })),

    on(fromActions.getCurrentUser.do, (state: FeatureState) => ({ ...state, error: undefined })),
    on(fromActions.getCurrentUser.success, (state: FeatureState, action) => ({
        ...state,
        currentUser: action.payload,
        error: undefined,
    })),
    on(fromActions.getCurrentUser.failure, (state: FeatureState, action) => ({
        ...state,
        currentUser: undefined,
        error: action.payload,
    })),

    on(fromActions.updateCurrentUser.do, (state: FeatureState) => ({ ...state, error: undefined })),
    on(fromActions.updateCurrentUser.success, (state: FeatureState, action) => ({
        ...state,
        currentUser: { ...state.currentUser, ...action.payload },
        error: undefined,
    })),
    on(fromActions.updateCurrentUser.failure, (state: FeatureState, action) => ({
        ...state,
        currentUser: undefined,
        error: action.payload,
    })),

    on(fromActions.setCurrentUser, (state: FeatureState, action) => ({
        ...state,
        currentUser: { ...state.currentUser, ...action.payload },
    })),

    on(fromActions.logout.do, (state: FeatureState) => ({ ...state })),
    on(fromActions.logout.success, (state: FeatureState) => ({
        ...state,
        error: undefined,
    })),
    on(fromActions.logout.failure, (state: FeatureState, action) => ({
        ...state,
        error: action.payload,
    })),

    on(fromActions.signup.do, (state: FeatureState) => ({ ...state, error: undefined })),
    on(fromActions.signup.success, (state: FeatureState) => ({
        ...state,
        error: undefined,
    })),
    on(fromActions.signup.failure, (state: FeatureState, action) => {
        return {
            ...state,
            error: action.payload,
        };
    }),

    on(fromActions.password.sendEmailForReset, (state: FeatureState) => ({ ...state, error: undefined })),
    on(fromActions.password.sendEmailForResetSuccess, (state: FeatureState) => ({ ...state, error: undefined })),
    on(
        fromActions.password.sendEmailForResetFailed,
        (state: FeatureState, action: fromActions.ActionWithPayload<HttpErrorResponse>) => ({
            ...state,
            error: action.payload,
        }),
    ),
    on(fromActions.password.set, (state: FeatureState) => ({ ...state, error: undefined })),
    on(fromActions.password.setSuccess, (state: FeatureState) => ({ ...state, error: undefined })),
    on(fromActions.password.setFailed, (state: FeatureState, action) => {
        return { ...state, error: action.payload };
    }),

    on(fromActions.password.change, (state: FeatureState) => ({ ...state, error: undefined })),
    on(fromActions.password.changeSuccess, (state: FeatureState) => ({ ...state, error: undefined })),
    on(fromActions.password.changeFailed, (state: FeatureState, action) => ({ ...state, error: action.payload })),

    on(UserActions.dismissBannerSuccess, (state, { dismissedBanners }) => ({
        ...state,
        currentUser: state.currentUser ? { ...state.currentUser, dismissedBanners } : undefined,
    })),

    on(UserActions.updateLastSeenReleaseIdSuccess, (state, releaseId) => ({
        ...state,
        currentUser: state.currentUser ? { ...state.currentUser, lastSeenReleaseId: releaseId.releaseId } : undefined,
    }))
);

export const authFeature = createFeature({
    name: 'aumicoUsersAuthMicroservice',
    reducer: usersReducer,
});

export const {
    name,
    reducer, // feature reducer
    selectCurrentUser,
    selectError,
    selectSignUpData,
} = authFeature;
